import Vue from 'vue'

let Delighted = {}
Delighted.install = function (Vue, options) {
  Vue.prototype.$Delighted = {}
  Vue.prototype.$Delighted.$start = function () {
    !function(e,t,r,n){if(!e[n]){for(var a=e[n]=[],i=["survey","reset","config","init","set","get","event","identify","track","page","screen","group","alias"],s=0;s<i.length;s++){var c=i[s];a[c]=a[c]||function(e){return function(){var t=Array.prototype.slice.call(arguments);a.push([e,t])}}(c)}a.SNIPPET_VERSION="1.0.1";var o=t.createElement("script");o.type="text/javascript",o.async=!0,o.src="https://d2yyd1h5u9mauk.cloudfront.net/integrations/web/v1/library/"+r+"/"+n+".js";var p=t.getElementsByTagName("script")[0];p.parentNode.insertBefore(o,p)}}(window,document,"Iy0XkU4ConVUwh7Y","delighted");
    window.delighted = delighted
  }
  Vue.prototype.$Delighted.$start()
  Vue.prototype.$Delighted.$updateUser = function (user) {
    if (!user || !user.phone_system) return;
    if (user.phone_system.use_users_login){
      window.delighted.survey({
        email: user.user.email,
        name: user.phone_system.organization_name + " (" + user.user.first_name + " " + user.user.last_name + ")",
        createdAt: user.phone_system.created_at,
        properties: {
          primary_contact_name: user.user.first_name + " " + user.user.last_name,
          company: user.phone_system.organization_name,
          phone_system_id: user.phone_system.id,
          user_id: user.user.id,
        }
      });
    }else{
      window.delighted.survey({
        email: user.phone_system.primary_contact_email,
        name: user.phone_system.organization_name + " (" + user.phone_system.primary_contact_name + ")",
        createdAt: user.phone_system.created_at,
        properties: {
          primary_contact_name: user.phone_system.primary_contact_name,
          company: user.phone_system.organization_name,
          phone_system_id: user.phone_system.id,
        }
      });
    }
  }
}

try {
  Vue.use(Delighted)
}catch(e) {
  console.log("DELIGHTED ERROR:", e);
}
